import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

// 查询诊所退款信息
export function queryRefund(data) {
  return request(`${BASE_API}/refund/list`, {
    method: 'post',
    data
  })
}

// 添加退款
export function addOrderRefund(data) {
  return request(`${BASE_API}/refund/save`, {
    method: 'post',
    data
  })
}

// 查询订单退款信息
export function queryOrderRefund(data) {
  return request(`${BASE_API}/refund/list_by/${data.id}`)
}

// 审核不通过
export function refundFail(data) {
  return request(`${BASE_API}/refund/reject/${data.id}`, {
    method: 'POST'
  })
}

//导出
export function exportExcel(data){
  return request(`${BASE_API}/refund/list/data_export`,{method:'POST',data,responseType:'blob',download:true});
}